import React, { useCallback, useEffect } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import {
    resetSolar,
    SolarContractAnalysis,
} from "../../Redux/SolarContracts/SolarSlice";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: "bottom",
        },
        title: {
            display: true,
            text: "This year's contracts",
        },
    },
};
const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

let Cash = [];
let Godleap = [];
let Sunlight = [];

const LinerCaharts = () => {
    const dispatch = useDispatch();
    const { analysis } = useSelector((state) => state.contract);
    const analysisV = analysis?.data;
    useEffect(() => {
        const CallSolarContractAction = async () => {
            await dispatch(SolarContractAnalysis());
            await dispatch(resetSolar());
        };
        CallSolarContractAction();
    }, []);

    const data = {
        labels,
        datasets: [
            {
                label: "Cash",
                data: Cash,
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
            {
                label: "Godleap",
                data: Godleap,
                borderColor: "rgb(53, 162, 235)",
                backgroundColor: "rgba(53, 162, 235, 0.5)",
            },
            {
                label: "Sunlight",
                data: Sunlight,
                borderColor: "rgb(255 216 120)",
                backgroundColor: "rgba(255 216 120,0.2)",
            },
        ],
    };
    useEffect(() => {
        if (analysisV) {
            analysisV?.map((main) => {
                if (Cash.length < 12) Cash.push(main.cash);
                if (Godleap.length < 12) Godleap.push(main.goodleap);
                if (Sunlight.length < 12) Sunlight.push(main.sunlight);
            });
        }
    }, [analysisV]);

    return <Line options={options} data={data} />;
};

export default LinerCaharts;
